import { render, staticRenderFns } from "./Head.vue?vue&type=template&id=32e9de48&"
import script from "./Head.vue?vue&type=script&lang=ts&"
export * from "./Head.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports